import { useQuery } from "@tanstack/react-query";
import { CommunicationKitSummary } from "@ac-expo/api-types";
import { privateAxios } from "../axiosInstances";
import { communicationKitQueryKeys } from "../query-keys";

const getCommunicationKitsByOrganiser = async () => {
  const { data } = await privateAxios.get<CommunicationKitSummary[]>(
    "/communication-kits/me"
  );
  return data;
};

export const useGetCommunicationKitsByOrganiser = () =>
  useQuery({
    queryKey: communicationKitQueryKeys.me(),
    queryFn: getCommunicationKitsByOrganiser,
  });

const getCommunicationKitById = async (id: string) => {
  const { data } = await privateAxios.get(`/communication-kits/${id}`);
  return data;
};

export const useGetCommunicationKitById = (id: string, enabled: boolean) =>
  useQuery({
    queryKey: communicationKitQueryKeys.get(id),
    queryFn: () => getCommunicationKitById(id),
    enabled,
  });
